<template>
  <div>
    <van-nav-bar
      class="topBar"
      :title="llzName"
      left-text="返回"
      right-text="主页"
      left-arrow
      @click-left="onClickLeft"
      @click-right="handleHome"
    />
    <van-row class="top">
      <van-col span="22">
        <van-search
          v-model="searchForm.dbName"
          placeholder="请输入代表姓名"
        />
      </van-col>
      <van-col>
        <van-button
          class="submitBtn"
          icon="success"
          type="info"
          plain
          size="mini"
          round
          @click="onSearch"
        >
        </van-button>
      </van-col>
    </van-row>
    <div class="con">
      <div
        class="card"
        v-for="(el, index) in dbList"
        :key="index"
      >
        <van-row>
          <van-col span="4">
            <div v-if="el.dbHeadicon && el.dbHeadicon.indexOf('http') >= 0">
              <img
                :src="el.dbHeadicon"
                class="dbimg"
              />
            </div>
            <div v-if="el.dbHeadicon && el.dbHeadicon.indexOf(1) >= 0">
              <img
                :src="http + el.dbHeadicon + '&type=1'"
                class="dbimg"
              />
            </div>
            <div v-else>
              <img
                :src="require('@/assets/images/7.png')"
                class="dbimg"
              />
            </div>
          </van-col>
          <van-col span="20">
            <div class="dbname">
              <span>{{ el.dbName }}</span>
              <span class="sex">{{ el.sex }}</span>
              <span class="level">{{ el.dbjb }}</span>
            </div>
            <div class="dbdetail">
              <span v-if="el.company && el.company !== ''">{{
                el.company
              }}</span>
              <span v-else>暂无代表相关信息</span>
            </div>
          </van-col>
        </van-row>
        <van-row>
          <div
            class="bottom"
            @click="toLink(el.id)"
          >
            <!-- <van-button icon="edit" plain type="info" size="mini" round>提建议</van-button> -->
            <van-icon name="edit" />
            <span class="advice">提建议</span>
          </div>
        </van-row>
      </div>
    </div>
  </div>
</template>
<script>
import request from '@/api/getLLZ.js'
export default {
  data () {
    return {
      dbList: [],
      llzId: '',
      llzName: '',
      http: this.$api,
      searchForm: {
        dbName: ''
      }
    }
  },
  created () {
    this.llzId = this.$route.query.llzId
    this.llzName = this.$route.query.llzName
    console.log(this.llzId, '联络站id')
    this.fetchDBlist()
  },
  mounted () {
    // this.fetchDBlist()
  },

  methods: {
    onSearch () {
      this.fetchDBlist()
      this.searchForm = {}
    },
    handleHome () {
      this.$router.push('/home')
    },
    fetchDBlist () {
      const reqData = {
        pageIndex: 1,
        pageSize: 500,
        llzid: this.llzId,
        ...this.searchForm
      }
      request
        .llzDBList(reqData)
        .then((res) => {
          // console.log(res)
          this.dbList = res.list
        })
        .catch((error) => {
          console.log(error)
        })
    },
    toLink (val) {
      location.href = process.env.VUE_APP_BASE_PC_URL + '#/infodetail_qr?id=' + val + '&from=wxoa'
    },
    onClickLeft () {
      this.$router.go(-1)
    }
  }
}
</script>
<style lang="less" scoped>
.topBar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
}
.top {
  position: fixed;
  top: 12vw;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  z-index: 9999;
  background: #fff;
}
.con {
  margin-top: 200px;
  padding: 10px;
  background: rgb(243, 243, 243);
  //   height: 100vh;
  .card {
    margin: 20px auto;
    background: #fff;
    padding: 20px 10px;
  }
  .dbimg {
    width: 80%;
    height: 90px;
  }
  .dbname {
    font-size: 34px;
    font-weight: 600;
    border-bottom: 1px solid rgb(218, 218, 218);
    padding-bottom: 8px;
    .sex {
      font-size: 28px;
      color: #727071;
      font-family: '楷体';
      padding-left: 20px;
    }
    .level {
      font-size: 28px;
      color: #727071;
      font-family: '楷体';
      padding-left: 20px;
    }
  }
  .dbdetail {
    font-size: 28px;
    line-height: 40px;
    margin-top: 10px;
    color: #a5a2a2;
    // font-family: Arial;
    font-family: Source Han Sans CN;
  }
  .adviceBtn {
    padding-top: -10px;
  }
  .bottom {
    margin-top: 28px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .advice {
    font-size: 26px;
    padding-left: 10px;
    font-family: Source Han Sans CN;
    // border-right: 1px solid #d8d8d8;
  }
}
</style>
